import React from 'react'
import useCustomNavigate from "../../Hook/useCustomNavigate";

function Testfile() {
  const navigate = useCustomNavigate();

  return (
    <div>
      <button onClick={() => navigate("/dashboard")}>
        Go to Dashboard
      </button>

    </div>
  )
}

export default Testfile
